import Link from "components/base/Link";
import Text from "components/base/Text";
import {
  MotionBox as Box,
  MotionFlex as Flex,
  MotionGrid as Grid,
  MotionGridItem as GridItem,
} from "utils/motion";
import Image from "components/base/Image";
import Trans from "components/base/Trans";

const EventPostItem = ({ data }) => (
  <Box bg="gray.900" color="white" my={["sm", "md", "md", "lg"]}>
    <Grid
      templateColumns="repeat(12, 1fr)"
      gap={["md"]}
      px={[4, 4, null, 6]}
      py={[4, 4, null, 6]}
      initial="regular"
    >
      <GridItem colSpan={[12, 12, 3, 2]}>
        <Image
          src={data.thumbnail.url}
          alt={data.thumbnail.alt}
          objectFit="contain"
          minHeight="140"
          maxHeight="240"
          minWidth="100%"
          bg="white"
          objectPosition="center"
        />
      </GridItem>
      <GridItem colSpan={[12, 12, 6, 7]}>
        <Text type="p_md" color="white" textTransform="none" fontWeight="bold">
          {data.display_date ?? ""}
        </Text>
        <Text type="title_lg" color="white" mt="xs">
          {data.title?.[0]?.text ?? ""}
        </Text>
        <Text
          type="p_sm"
          color="white"
          w={["100%", "100%", "90%", "70%"]}
          mt="xxs"
        >
          {data.description?.[0]?.text ?? ""}
        </Text>
        <Flex pt="md" pb="xxs" gap="md">
          {data.link_details?.url ? (
            <Link
              href={data.link_details.url}
              target={data.link_details.target}
              fontWeight="bold"
            >
              <Trans id="LBL_EVENTS_SEE_DETAILS" />
            </Link>
          ) : null}
          {data.link_register?.url ? (
            <Link
              href={data.link_details.url}
              target={data.link_details.target}
              fontWeight="bold"
            >
              <Trans id="LBL_EVENTS_REGISTER" />
            </Link>
          ) : null}
        </Flex>
      </GridItem>

      <GridItem colSpan={[12, 12, 3, 3]}>
        <Flex justify="center" direction="column" height="100%">
          <Text type="p_sm" color="white" fontWeight="bold" pb="sm">
            {data.booth}
          </Text>
          <Text type="p_sm" fontWeight="bold" color="white" pb="xs">
            {data.location}
          </Text>
          <Text type="p_sm" color="white">
            {data.location_2_line}
          </Text>
          <Text type="p_sm" color="white">
            {data.location_country}
          </Text>
        </Flex>
      </GridItem>
    </Grid>
  </Box>
);

export default EventPostItem;
